const styles = theme => ({
  cancelButton: {
    color: [theme.palette.primary.default, "!important"],
    marginRight: theme.spacing(2)
  },
  editCardContainer: {
    color: theme.palette.primary.default,
    marginLeft: theme.spacing(1)
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Settings/UpdateCardInfo/styles.js